import { CheckCircle2 } from "lucide-react";
import { TRUST_STATS } from "@/lib/clinic";

const BULLETS = [
  "Fully sterilised, autoclave-tested instruments for every patient",
  "Modern digital X-ray with 90% less radiation",
  "Rotary root canals — most cases done in a single visit",
  "Warm, family-friendly team fluent in Hindi, Haryanvi & English",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="section-about"
      className="py-20 md:py-28 bg-[#FAFAF9]"
    >
      <div className="container-x grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-3 bg-[#D4B27E]/25 rounded-[2rem] rotate-2" aria-hidden />
            <img
              src="/clinic/reception.jpg"
              alt="City Smiles Dental Clinic reception — plants, comfortable seating and the illuminated clinic logo"
              className="relative rounded-[2rem] w-full h-[440px] md:h-[520px] object-cover object-center soft-shadow-lg"
            />
            <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur rounded-full px-4 py-1.5 text-xs font-medium text-[#1C221F] border border-stone-200">
              Our reception · Ratia
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-[#2D4A3E] font-medium">
            About the clinic
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1C221F] tracking-tight">
            Ratia&apos;s most trusted address for a healthy, confident smile.
          </h2>
          <p className="mt-5 text-[#57605B] leading-relaxed">
            City Smiles Dental Clinic has been serving families in Ratia and surrounding villages for
            over a decade. We blend the calm of a small-town clinic with the equipment of a big-city
            practice — so you get world-class care without the world-class waiting rooms.
          </p>

          <ul className="mt-6 space-y-3">
            {BULLETS.map((b) => (
              <li key={b} className="flex items-start gap-3 text-[#1C221F]/85">
                <CheckCircle2 className="w-5 h-5 text-[#2D4A3E] mt-0.5 shrink-0" strokeWidth={1.75} />
                <span className="text-sm sm:text-base">{b}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {TRUST_STATS.map((s) => (
              <div
                key={s.label}
                data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="rounded-2xl bg-white border border-stone-200 p-4 text-center soft-shadow"
              >
                <div className="font-display text-2xl font-bold text-[#2D4A3E]">{s.value}</div>
                <div className="text-xs text-[#57605B] mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
